<template>
    <div>
        <v-snackbar v-model="snackbar" top :color="color" :timeout="6000">
            <span v-if="snackbar_msg">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <br>
        <v-card flat>
            <!-- overall fee collection -->
            <v-skeleton-loader v-if="loadingFeeChart" class="mx-auto" max-width="700" type="image"></v-skeleton-loader>

            <div v-else-if="overall_fee_collection" class="d-flex align-start justify-center flex-wrap"
                style="gap: 40px;">

                <div style="width: 500px; min-width: 300px;">
                    <chart style="width: 100%; height: 420px;" auto-resize :options="feeCollectionPieChart"></chart>
                </div>

                <div class="d-flex flex-column" style="min-width: 260px; gap: 18px; margin-top: 80px;">
                    <v-card class="pa-4 text-center" outlined>
                        <div class="grey--text text-caption">
                            Expected (in Lakhs)
                        </div>
                        <div class="font-weight-bold" style="color: #003049;">
                            {{ overall_fee_collection.expectedCollection }} L
                        </div>
                    </v-card>

                    <v-card class="pa-4 text-center" outlined>
                        <div class="grey--text text-caption">
                            Collected (in Lakhs)
                        </div>
                        <div class="font-weight-bold" style="color: #22aaa1;">
                            {{ overall_fee_collection.collectedAmount }} L
                        </div>
                    </v-card>

                    <v-card class="pa-4 text-center" outlined>
                        <div class="grey--text text-caption">
                            Remaining (in Lakhs)
                        </div>
                        <div class="font-weight-bold" style="color: #d62828;">
                            {{ overall_fee_collection.remainingAmount }} L
                        </div>
                    </v-card>
                </div>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No fee collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- class wise fee collection -->
            <v-skeleton-loader v-if="loadingClassFeeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="class_wise_fee_collection.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="classWiseCollectionChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No class wise fee collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- section wise fee collection -->
            <v-skeleton-loader v-if="loadingSectionFeeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="section_wise_fee_collection.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="sectionWiseCollectionChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No Section wise fee collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- fee type wise collection -->
            <v-skeleton-loader v-if="loadingFeeTypeFeeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="fee_type_wise_fee_collection.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="feeTypeWiseCollectionChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No Fee Type-wise fee collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- payment mode wise collection -->
            <v-skeleton-loader v-if="loadingPaymentModeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="payment_mode_wise_fee_collection.length > 0"
                class="d-flex align-start justify-center flex-wrap" style="gap: 40px;">

                <div style="width: 500px;">
                    <chart style="width: 100%; height: 470px;" auto-resize :options="paymentModePieChart"></chart>
                </div>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No payment mode wise collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- class wise fee dues -->
            <v-skeleton-loader v-if="loadingClassDueFeeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="class_wise_fee_collection.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="classWiseFeesDueChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No class wise fees due data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- section wise fee dues -->
            <v-skeleton-loader v-if="loadingSectionDueFeeChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="section_wise_fee_collection.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="sectionWiseFeesDueChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No Section wise fee collection data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- class wise concession -->
            <v-skeleton-loader v-if="loadingClassConcessionChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="class_wise_concession.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="classWiseConcessionChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No Class wise concession data available
            </div>

            <v-divider class="my-5"></v-divider>
            <!-- section wise concession -->
            <v-skeleton-loader v-if="loadingSectionConcessionChart" class="mx-auto" max-width="700"
                type="image"></v-skeleton-loader>

            <div v-else-if="section_wise_concession.length > 0">
                <chart style="width: 950px; height: 400px;" auto-resize :options="sectionWiseConcessionChart"></chart>
            </div>

            <div v-else class="text-center py-5 grey--text">
                No Section wise concession data available
            </div>
        </v-card>

    </div>
</template>

<script>
import axios from "axios";

import UnderDevelopement from '../shared/UnderDevelopement.vue';
export default {

    props: [
        'selected_ay',
        'selected_semester',
        'selected_standard',
        'selected_div',
        'selected_course',
        'selected_learner',
        'render1',
    ],
    components: { UnderDevelopement },
    data() {
        return {
            color: "",
            snackbar: false,
            snackbar_msg: null,
            overall_fee_collection: [],
            class_wise_fee_collection: [],
            section_wise_fee_collection: [],
            fee_type_wise_fee_collection: [],
            payment_mode_wise_fee_collection: [],
            class_wise_concession: [],
            loadingFeeChart: false,
            loadingClassFeeChart: false,
            loadingSectionFeeChart: false,
            loadingFeeTypeFeeChart: false,
            loadingPaymentModeChart: false,
            loadingClassDueFeeChart: false,
            loadingSectionDueFeeChart: false,
            loadingClassConcessionChart: false,
            loadingSectionConcessionChart: false,

            feeCollectionPieChart: {
                title: {
                    text: "Expected Collection Vs Actual Collection (In Lakhs)",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },

                color: [
                    {
                        type: 'linear',
                        x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#f7c2a1' },
                            { offset: 1, color: '#9c6644' }
                        ]
                    },
                    {
                        type: 'linear',
                        x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#6ef5ec' },
                            { offset: 1, color: '#22aaa1' }
                        ]
                    }
                ],

                tooltip: {
                    trigger: "item",
                    formatter: "{b}: {c} L ({d}%)"
                },

                legend: {
                    orient: "horizontal",
                    bottom: 5,
                    data: ["Expected", "Collected"]
                },

                series: [
                    {
                        name: "Fee Collection",
                        type: "pie",
                        radius: "65%",
                        center: ["50%", "48%"],
                        data: [
                            { value: 0, name: "Expected" },
                            { value: 0, name: "Collected" }
                        ],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 15,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0,0,0,0.25)"
                            }
                        }
                    }
                ]
            },
            classWiseCollectionChart: {
                title: {
                    text: "Class-wise Fees Collection",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter: "{b}<br/>Collected: {c} L"
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Class",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: {
                    type: "value",
                    name: "Amount (Lakhs)",
                    nameLocation: "middle",
                    nameGap: 50,
                    axisLabel: {
                        formatter: "{value} L"
                    }
                },
                series: [
                    {
                        name: "Collected",
                        type: "bar",
                        barWidth: "45%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#d1cffa' },
                                    { offset: 1, color: '#9381ff' }
                                ]
                            }
                        }
                    }
                ]
            },
            sectionWiseCollectionChart: {
                title: {
                    text: "Section-wise Fees Collection",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter: "{b}<br/>Collected: {c} L"
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Section",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: {
                    type: "value",
                    name: "Amount (Lakhs)",
                    nameLocation: "middle",
                    nameGap: 50,
                    axisLabel: {
                        formatter: "{value} L"
                    }
                },
                series: [
                    {
                        name: "Collected",
                        type: "bar",
                        barWidth: "45%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#f79eaa' },
                                    { offset: 1, color: '#fa3c56' }
                                ]
                            }
                        }
                    }
                ]
            },
            feeTypeWiseCollectionChart: {
                title: {
                    text: "Fee Type-wise Fees Collection",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter: "{b}<br/>Collected: {c} L"
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Fee Type",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: {
                    type: "value",
                    name: "Amount (Lakhs)",
                    nameLocation: "middle",
                    nameGap: 50,
                    axisLabel: {
                        formatter: "{value} L"
                    }
                },
                series: [
                    {
                        name: "Collected",
                        type: "bar",
                        barWidth: "45%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#81f7f3' },
                                    { offset: 1, color: '#07beb8' }
                                ]
                            }
                        }
                    }
                ]
            },
            paymentModePieChart: {
                title: {
                    text: "Payment Mode Distribution",
                    left: "center",
                    top: 10,
                    padding: [0, 0, 20, 0],
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "item",
                    formatter: "{b}: ({d}%)"
                },
                legend: {
                    bottom: 0,
                    left: "center",
                    itemWidth: 14,
                    itemHeight: 14,
                    padding: [10, 0, 5, 0],
                    textStyle: {
                        fontSize: 13
                    }
                },
                color: [
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#f5bcde' },
                            { offset: 1, color: '#f229a2' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#b3e3f5' },
                            { offset: 1, color: '#00bbf9' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#d9c6f7' },
                            { offset: 1, color: '#8734eb' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#edf5bf' },
                            { offset: 1, color: '#b9d126' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#abf5eb' },
                            { offset: 1, color: '#00f5d4' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#edbf9e' },
                            { offset: 1, color: '#da9461' }
                        ]
                    },
                    {
                        type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                        colorStops: [
                            { offset: 0, color: '#ebf4f5' },
                            { offset: 1, color: '#95a5c0' }
                        ]
                    }
                ],
                series: [
                    {
                        name: "Fee Collection",
                        type: "pie",
                        radius: "55%",
                        center: ["50%", "52%"],
                        label: {
                            show: true,
                            formatter: "{b}\n{d}%",
                            fontWeight: "500"
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 15,
                                shadowOffsetX: 0,
                                shadowColor: "rgba(0,0,0,0.25)"
                            }
                        },
                        animation: true,
                        animationDuration: 800,
                        data: []
                    }
                ]
            },
            classWiseFeesDueChart: {
                title: {
                    text: "Class-wise Fee Dues",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter: "{b}<br/>Dues: {c} L"
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Class",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: {
                    type: "value",
                    name: "Amount (Lakhs)",
                    nameLocation: "middle",
                    nameGap: 50,
                    axisLabel: {
                        formatter: "{value} L"
                    }
                },
                series: [
                    {
                        name: "Dues",
                        type: "bar",
                        barWidth: "45%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#f5cf8e' },
                                    { offset: 1, color: '#ff9500' }
                                ]
                            }
                        }
                    }
                ]
            },
            sectionWiseFeesDueChart: {
                title: {
                    text: "Section-wise Fee Dues",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    },
                    formatter: "{b}<br/>Dues: {c} L"
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Section",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: {
                    type: "value",
                    name: "Amount (Lakhs)",
                    nameLocation: "middle",
                    nameGap: 50,
                    axisLabel: {
                        formatter: "{value} L"
                    }
                },
                series: [
                    {
                        name: "Dues",
                        type: "bar",
                        barWidth: "45%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#e7f5ba' },
                                    { offset: 1, color: '#9ac40c' }
                                ]
                            }
                        }
                    }
                ]
            },
            classWiseConcessionChart: {
                title: {
                    text: "Class-wise Concession",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    bottom: 5,
                    data: ["Concession (L)", "Students"]
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Class",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: "Concession (Lakhs)",
                        nameLocation: "middle",
                        nameGap: 50,
                        axisLabel: {
                            formatter: "{value} L"
                        }
                    },
                    {
                        type: "value",
                        name: "Students",
                        position: "right",
                        nameLocation: "middle",
                        nameGap: 50
                    }
                ],
                series: [
                    {
                        name: "Concession (L)",
                        type: "bar",
                        barWidth: "35%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#ffeb99' },
                                    { offset: 1, color: '#ffc000' }
                                ]
                            }
                        }
                    },
                    {
                        name: "Students",
                        type: "bar",
                        yAxisIndex: 1,
                        barWidth: "35%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#dabfff' },
                                    { offset: 1, color: '#54318c' }
                                ]
                            }
                        }
                    }
                ]
            },
            sectionWiseConcessionChart: {
                title: {
                    text: "Section-wise Concession",
                    left: "center",
                    top: 10,
                    textStyle: {
                        fontSize: 18,
                        fontWeight: "600",
                        color: "#2c3e50"
                    }
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow"
                    }
                },
                legend: {
                    bottom: 5,
                    data: ["Concession (L)", "Students"]
                },
                grid: {
                    left: "10%",
                    right: "10%",
                    bottom: "20%",
                    top: "18%"
                },
                xAxis: {
                    type: "category",
                    name: "Section",
                    data: [],
                    axisLabel: {
                        fontSize: 13,
                        rotate: 45,
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        name: "Concession (Lakhs)",
                        nameLocation: "middle",
                        nameGap: 50,
                        axisLabel: {
                            formatter: "{value} L"
                        }
                    },
                    {
                        type: "value",
                        name: "Students",
                        position: "right",
                        nameLocation: "middle",
                        nameGap: 50
                    }
                ],
                series: [
                    {
                        name: "Concession (L)",
                        type: "bar",
                        barWidth: "35%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#fec9d7' },
                                    { offset: 1, color: '#ff5883' }
                                ]
                            }
                        }
                    },
                    {
                        name: "Students",
                        type: "bar",
                        yAxisIndex: 1,
                        barWidth: "35%",
                        data: [],
                        itemStyle: {
                            borderRadius: [6, 6, 0, 0],
                            color: {
                                type: 'linear',
                                x: 0, y: 0, x2: 0, y2: 1,
                                colorStops: [
                                    { offset: 0, color: '#b9eee1' },
                                    { offset: 1, color: '#39b89a' }
                                ]
                            }
                        }
                    }
                ]
            },

        };
    },
    mounted() {
        this.getOverallFeesCollectionData();
        this.getClassWiseFeesCollectionData();
        this.getSectionWiseFeesCollectionData();
        this.getFeeTypeWiseFeesCollectionData();
        this.getPaymentModeWiseFeesCollectionData();
        this.getClassWiseConcession();
        this.getSectionWiseConcession();

    },
    methods: {
        showSnackbar(color, msg) {
            this.snackbar = true;
            this.color = color;
            this.snackbar_msg = msg;
        },
        async getOverallFeesCollectionData() {
            this.loadingFeeChart = true;

            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard,
                learnerId: this.selected_learner,
            }

            try {
                const res = await axios.post(
                    "/AdminDashboard/getOverallFeesCollectionData",
                    data
                );

                if (res.data.flag === "YES") {
                    this.overall_fee_collection = res.data.overall_fee_collection;

                    const feeData = this.overall_fee_collection;

                    this.feeCollectionPieChart.series[0].data = [
                        {
                            value: feeData.expectedCollection,
                            name: "Expected"
                        },
                        {
                            value: feeData.collectedAmount,
                            name: "Collected"
                        }
                    ];

                } else {
                    this.overall_fee_collection = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }

            } catch (err) {
                this.overall_fee_collection = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingFeeChart = false;
            }
        },
        async getClassWiseFeesCollectionData() {
            this.loadingClassFeeChart = true;
            this.loadingClassDueFeeChart = true;

            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }

            try {
                const res = await axios.post("/AdminDashboard/getClassWiseFeesCollectionData", data);

                if (res.data.flag === "YES") {
                    this.class_wise_fee_collection = res.data.class_wise_fee_collection;
                    const sortedData = [...this.class_wise_fee_collection].sort((a, b) => {
                        return a.standardName.localeCompare(b.standardName, undefined, { numeric: true });
                    });

                    this.classWiseCollectionChart.xAxis.data = sortedData.map(
                        item => item.standardName
                    );

                    this.classWiseCollectionChart.series[0].data = sortedData.map(
                        item => item.collectedAmount
                    );
                    this.classWiseFeesDueChart.xAxis.data = sortedData.map(
                        item => item.standardName
                    );

                    this.classWiseFeesDueChart.series[0].data = sortedData.map(
                        item => item.remainingAmount
                    );

                } else {
                    this.class_wise_fee_collection = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                    this.loadingClassFeeChart = false;
                this.loadingClassDueFeeChart = false;
                }
            } catch (e) {
                this.class_wise_fee_collection = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingClassFeeChart = false;
                this.loadingClassDueFeeChart = false;
            }
        },
        async getSectionWiseFeesCollectionData() {
            this.loadingSectionFeeChart = true;
            this.loadingSectionDueFeeChart = true;

            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }

            try {
                const res = await axios.post("/AdminDashboard/getSectionWiseFeesCollectionData", data);

                if (res.data.flag === "YES") {
                    this.section_wise_fee_collection = res.data.section_wise_fee_collection;
                    const sortedData = [...this.section_wise_fee_collection].sort((a, b) => {
                        return a.sectionName.localeCompare(b.sectionName, undefined, { numeric: true });
                    });

                    this.sectionWiseCollectionChart.xAxis.data = sortedData.map(
                        item => item.sectionName
                    );

                    this.sectionWiseCollectionChart.series[0].data = sortedData.map(
                        item => item.collectedAmount
                    );
                    this.sectionWiseFeesDueChart.xAxis.data = sortedData.map(
                        item => item.sectionName
                    );

                    this.sectionWiseFeesDueChart.series[0].data = sortedData.map(
                        item => item.remainingAmount
                    );
                } else {
                    this.section_wise_fee_collection = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            } catch (e) {
                this.section_wise_fee_collection = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingSectionFeeChart = false;
                this.loadingSectionDueFeeChart = false;
            }
        },
        async getFeeTypeWiseFeesCollectionData() {
            this.loadingFeeTypeFeeChart = true;

            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }

            try {
                const res = await axios.post("/AdminDashboard/getFeeTypeWiseFeesCollectionData", data);

                if (res.data.flag === "YES") {
                    this.fee_type_wise_fee_collection = res.data.fee_type_wise_fee_collection;
                    const sortedData = [...this.fee_type_wise_fee_collection].sort((a, b) => {
                        return a.categoryName.localeCompare(b.categoryName, undefined, { numeric: true });
                    });

                    this.feeTypeWiseCollectionChart.xAxis.data = sortedData.map(
                        item => item.categoryName
                    );

                    this.feeTypeWiseCollectionChart.series[0].data = sortedData.map(
                        item => item.collectedAmount
                    );
                } else {
                    this.fee_type_wise_fee_collection = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            } catch (e) {
                this.fee_type_wise_fee_collection = null;
                this.showSnackbar("error", "Something went wrong");

            } finally {
                this.loadingFeeTypeFeeChart = false;
            }
        },
        async getPaymentModeWiseFeesCollectionData() {
            this.loadingPaymentModeChart = true;

            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }

            try {
                const res = await axios.post("/AdminDashboard/getPaymentModeWiseFeesCollectionData", data);

                if (res.data.flag === "YES") {
                    this.payment_mode_wise_fee_collection = res.data.payment_mode_wise_fee_collection;

                    const feeData = this.payment_mode_wise_fee_collection;

                    this.paymentModePieChart.series[0].data = feeData.map(item => ({
                        value: item.percentage,
                        name: item.paymentModeName,
                    }));
                } else {
                    this.payment_mode_wise_fee_collection = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            } catch (e) {
                this.payment_mode_wise_fee_collection = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingPaymentModeChart = false;
            }
        },
        async getClassWiseConcession() {
            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }
            this.loadingClassConcessionChart = true;

            try {
                const res = await axios.post("/AdminDashboard/getClassWiseConcession", data);

                if (res.data.flag === "YES") {
                    this.class_wise_concession = res.data.class_wise_concession;

                    const sortedData = [...this.class_wise_concession].sort((a, b) => {
                        return a.standardName.localeCompare(b.standardName, undefined, { numeric: true });
                    });

                    this.classWiseConcessionChart.xAxis.data =
                        sortedData.map(item => item.standardName);

                    this.classWiseConcessionChart.series[0].data =
                        sortedData.map(item => item.concessionAmount);

                    this.classWiseConcessionChart.series[1].data =
                        sortedData.map(item => item.studentCount);

                } else {
                    this.class_wise_concession = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            } catch (e) {
                this.class_wise_concession = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingClassConcessionChart = false;
            }
        },
        async getSectionWiseConcession() {
            const data = {
                academicyearId: this.selected_ay,
                standardIds: this.selected_standard
            }
            this.loadingSectionConcessionChart = true;

            try {
                const res = await axios.post("/AdminDashboard/getSectionWiseConcession", data);

                if (res.data.flag === "YES") {
                    this.section_wise_concession = res.data.section_wise_concession;

                    const sortedData = [...this.section_wise_concession].sort((a, b) => {
                        return a.sectionName.localeCompare(b.sectionName, undefined, { numeric: true });
                    });

                    this.sectionWiseConcessionChart.xAxis.data =
                        sortedData.map(item => item.sectionName);

                    this.sectionWiseConcessionChart.series[0].data =
                        sortedData.map(item => item.concessionAmount);

                    this.sectionWiseConcessionChart.series[1].data =
                        sortedData.map(item => item.studentCount);

                } else {
                    this.section_wise_concession = null;
                    this.showSnackbar("error", res.data.msg || "Failed to load data");
                }
            } catch (e) {
                this.section_wise_concession = null;
                this.showSnackbar("error", "Something went wrong");
            } finally {
                this.loadingSectionConcessionChart = false;
            }
        },
    }
};
</script>

<style scoped></style>
